import React from 'react';
import DataTable from 'components/data-table';
import { Danhmuc, GiaiQuyetDonThu } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {RowItemCapNhatNguoiDung} from './datatable/list';
import {Input, Text} from 'components/tt-forms/common';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import {
  DropDownMulipleUse
} from 'components/tt-forms';
import { ShowIf } from 'components/utils';
import {MasterLayout} from 'layout';

class CapNhatNguoiDung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataNguoiDungThayThe: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      maHoSo: '',
      hoTen: '',
      tableLoading: false,
      searchLoading: false,
      buttonLoading: false,
      search: false,
      nguoiDungHienTai: '',
      idNguoiDungHienTai: '',
      vaiTroNguoiDungHienTai: '',
      nguoiDungThayThe: '',
      maHoSoTraCuu: '',
      hoTenTraCuu: ''
    }
  }

  getListCongChuc(vaiTro, coQuanQuanLyId, idNguoiDungHienTai) {
    let params = {
      vaiTro: vaiTro,
      coQuanQuanLyId: coQuanQuanLyId,
      congChucHienTaiId: Number(idNguoiDungHienTai)
    }
    GiaiQuyetDonThu.actions.getCongChuc.request(params).then(res => {
      if(res.data._embedded) {
        this.setState({
          dataNguoiDungThayThe: res.data._embedded.congChucs
        })
      }
    })
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData(this.state.maHoSoTraCuu, this.state.hoTenTraCuu);
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData(this.state.maHoSoTraCuu, this.state.hoTenTraCuu);
  }

  getListData(maHoSo, hoTen) {
    if (this.validateSubmitForm()) {
      this.state.search = true;
      this.state.tableLoading = true;
      this.state.searchLoading = true;
      this.setState({
        ...this.state
      })
      let params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      }
      if (hoTen) {
        params.hoTen = hoTen;
        this.setState({
          hoTenTraCuu: hoTen
        })
      } else if (this.state.hoTen) {
        params.hoTen = this.state.hoTen;
        this.setState({
          hoTenTraCuu: this.state.hoTen
        })
      }
      if (maHoSo) {
        params.maHoSo = maHoSo;
        this.setState({
          maHoSoTraCuu: maHoSo
        })
      } else if (this.state.maHoSo) {
        params.maHoSo = this.state.maHoSo;
        this.setState({
          maHoSoTraCuu: this.state.maHoSo
        })
      }
      Danhmuc.actions.getCapNhatNguoiDung.request(null, params).then(res => {
        if(res.data._embedded) {
          this.state.data = res.data._embedded.congChucs;
          this.state.tableLoading = false;
          this.state.searchLoading = false;
          this.state.pageData = res.data.page;
          this.setState({
            ...this.state
          })
        } else {
          this.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            searchLoading: false,
            tableLoading: false
          })
        }
      })
    }
  }

  openDialog(vaiTro, coQuanQuanLyId, nguoiDungHienTai, vaiTroNguoiDungHienTai, idNguoiDungHienTai) {
    this.getListCongChuc(vaiTro, coQuanQuanLyId, idNguoiDungHienTai)
    this.state.isOpen = true;
    this.state.nguoiDungHienTai = nguoiDungHienTai;
    this.state.idNguoiDungHienTai = idNguoiDungHienTai;
    this.state.vaiTroNguoiDungHienTai = vaiTroNguoiDungHienTai;
    this.setState({
      ...this.state
    })
  }

  closeDialog() {
    this.state.isOpen = false;
    this.state.nguoiDungThayThe = '';
    this.state.idNguoiDungHienTai = '';
    this.state.dataNguoiDungThayThe = [];
    this.setState({
      ...this.state
    })
  }

  updateUser() {
    if(this.validateUpdateForm()) {
      this.state.buttonLoading = true;
      this.setState({
        ...this.state
      })
      let params = {
        maHoSo: this.state.maHoSoTraCuu,
        canBoXuLyThayTheId: Number(this.state.nguoiDungThayThe),
        canBoDangXuLyId: Number(this.state.idNguoiDungHienTai),
      }
      Danhmuc.actions.updateCapNhatNguoiDung.request(params).then(res => {
        this.closeDialog();
        this.state.buttonLoading = false;
        this.setState({
          ...this.state
        })
        this.getListData(this.state.maHoSoTraCuu, this.state.hoTenTraCuu);
        Toastr('Thay thế người dùng thành công', 'success');
      }).catch(err => {
        this.state.buttonLoading = false;
        this.setState({
          ...this.state
        })
        Toastr('Lỗi hệ thống', 'error');
      })
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  validateUpdateForm() {
    let pass = true;
    this.props.validators['formCapNhat'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  componentWillUnmount() {

  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-reception"></i>Cập nhật người dùng</p>
          </div>
        </div>
        <div className="bottom-content">
          <div className='row pt20 pl25 pr25 pb5'>
            <Input className='col-25' require bindValidator={this} channel='formTaoDon' value={this.state.maHoSo} onChange={this.onChange.bind(this, 'maHoSo')} name='maHoSo' label='Mã hồ sơ' placeholder='Nhập...'/>
            <Input className='col-25' value={this.state.hoTen} onChange={this.onChange.bind(this, 'hoTen')} name='hoTen' label='Họ tên' placeholder='Nhập...'/>
            <div className='col-25 mt22'>
              <button onClick={this.getListData.bind(this, null, null)} className={`pt-button btn-green tt-search ${this.state.searchLoading ? 'btn-loading-inline' : ''}`}>Tìm kiếm</button>
            </div>
          </div>
          <div className='line-border'/>
          <DataTable
            header = {header.categoryGroup.capNhatNguoiDung}
            dataList={this.state.data}
            hideButtonExport
            pageData={this.state.pageData}
            parent= {this}
            tableLoading = {this.state.searchLoading}
            search={this.state.search}
          >
            <RowItemCapNhatNguoiDung openDialog={this.openDialog.bind(this)}/>
          </DataTable>
          <Dialog
            isOpen={this.state.isOpen}
            onClose={this.closeDialog.bind(this)}
            title="Xác nhận"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <Text className="col-50" label="Người dùng hiện tại:" value={this.state.nguoiDungHienTai}/>
              <Text className="col-50" label="Vai trò:" value={this.state.vaiTroNguoiDungHienTai}/>
              <ShowIf condition={this.state.dataNguoiDungThayThe.length == 0}>
                <p className='txt-center text-13 txt-bold col-100 mb18'>Không có tài khoản cùng vai trò để thay thế</p>
              </ShowIf>
              <ShowIf condition={this.state.dataNguoiDungThayThe.length > 0}>
                <DropDownMulipleUse className="col-50" label="Người dùng thay thế" channel='formCapNhat' require bindValidator={this} selectedValue={this.state.nguoiDungThayThe} onChange={this.onChange.bind(this, 'nguoiDungThayThe')} name='nguoiDungThayThe' data={this.state.dataNguoiDungThayThe} keyName='congChucId' valueName='hoVaTen'/>
              </ShowIf>
            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <ShowIf condition={this.state.dataNguoiDungThayThe.length > 0}>
                  <Link className={`btn-action btn-green ${this.state.buttonLoading ? "btn-loading-inline" : ""}`} onClick={this.updateUser.bind(this)} >
                    <span>Đồng ý</span>
                  </Link>
                </ShowIf>
            </div>
          </Dialog>
        </div>
      </div>
      </MasterLayout>
    )
  }
}

CapNhatNguoiDung.defaultProps={
  validators: {
    formTaoDon: [],
    formCapNhat: []
  }
}

export default CapNhatNguoiDung;



// WEBPACK FOOTER //
// ./src/components/modules/category/CapNhatNguoiDung.jsx